import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { setIndex } from "../marketUXSlice";
import { PageIndex } from "../../../models";

export const useMarketDataIndex = () => {
	const index = useSelector<StoreType, PageIndex>(s => s.ux.domestic.marketData.index);

	const dispatch = useDispatch();
	const dispatchSetIndex = React.useCallback((index: PageIndex) => dispatch(setIndex(index)), [dispatch]);

	return [index, dispatchSetIndex] as [typeof index, typeof dispatchSetIndex];
};
